// https://lospec.com/palette-list/cc-29

export default {
  white: '#f2f0e5',
  grayLight: '#b8b5b9',
  gray: '#45444f',
  grayDark: '#3a3858',
  black: '#212123',
  purpleDark: '#352b42',
  purple: '#43436a',
  blue: '#4b80ca',
  lightBlue: '#68c2d3',
  red: '#b45252',
  brown: '#80493a',
  lightGreen: '#c2d368',
  green: '#8ab060',
  darkGreen: '#4e584a',
  pink: '#cf8acb',
  yellow: '#ede19e',
};
